import { useState, useEffect } from "react";

// Živý odpočet do konca SÚŤAŽE (výzva s vlastným výsledkom). Súťaž sa vyhodnocuje k dátumu,
// takže „ostáva 1 deň" bolo hrubé — odpočet ukáže presne, koľko času na zápis výsledku ostáva.
// `ends_at` posiela backend ako 'YYYY-MM-DD HH:MM:SS' (lokálny čas, deň konca vrátane → 23:59:59).
// Formát: nad deň „2 d 04:12:07", pod deň „04:12:07"; po termíne „Ukončené".

// Bezpečné parsovanie: Safari nezvláda 'YYYY-MM-DD HH:MM:SS' cez Date(...) — rozoberáme ručne
// a skladáme lokálny čas (rovnaká pomôcka ako inde v appke pri backendových časoch).
export function parseLocal(s) {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(s);
  if (!m) return null;
  return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
}

// ms → { d, hh, mm, ss } (dvojmiestne reťazce pre hodiny/minúty/sekundy)
export function splitLeft(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const two = (n) => String(n).padStart(2, "0");
  return {
    d: Math.floor(total / 86400),
    hh: two(Math.floor((total % 86400) / 3600)),
    mm: two(Math.floor((total % 3600) / 60)),
    ss: two(total % 60),
  };
}

export function countdownText(endsAt, now) {
  const end = parseLocal(endsAt);
  if (!end) return null;
  const left = end.getTime() - now;
  if (left <= 0) return "Ukončené";
  const { d, hh, mm, ss } = splitLeft(left);
  return d > 0 ? `${d} d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
}

// v28.9 — do výzvy sa dá zapojiť ešte pred jej štartom (globálna dávka sa ohlási vopred).
// Kým nezačala, odpočet beží DO ŠTARTU; keď štart prebehne, sám sa prepne na odpočet do konca.
export function countdownTarget(startsAt, endsAt, now) {
  const s = parseLocal(startsAt);
  return s && s.getTime() > now ? startsAt : endsAt;
}

export function Countdown({ endsAt, startsAt }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!endsAt && !startsAt) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [endsAt, startsAt]);
  const txt = countdownText(countdownTarget(startsAt, endsAt, now), now);
  if (!txt) return null;
  // tabulárne číslice — inak by sa šírka pri každom tiknutí hýbala
  return <span className="bz-countdown">{txt}</span>;
}
